module.exports = __webpack_public_path__ + "img/1_1-finanziario-palazzo-1.c57526a7.png";